import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import { getChampions } from "@/lib/champions";

export default function ChampBadge({ userId, className = "" }) {
  const [champs, setChamps] = useState(null);
  useEffect(() => {
    let on = true;
    getChampions().then((c) => { if (on) setChamps(c); });
    return () => { on = false; };
  }, []);
  const n = userId && champs ? champs[userId] : 0;
  if (!n) return null;
  return (
    <span data-testid={`champion-badge-${userId}`} title={`Tournament Champion — ${n} title${n === 1 ? "" : "s"}`}
      className={`inline-flex align-middle ml-1 ${className}`}>
      <Trophy className="w-3.5 h-3.5 text-yellow-400 fill-yellow-400 drop-shadow-[0_0_4px_rgba(250,204,21,0.65)]" />
    </span>
  );
}
